export const handleLogout = () => {
    localStorage.removeItem("auth")
    window.location.replace("/login");
  }